// @flow
import * as React from 'react';
import Moment from 'react-moment';
import {Body} from 'sail/Text';

import type {IntegrationCheckersDataIntegrationCheckerScenarioResult} from '../../generatedTypes';

type IntegrationCheckerResultProps = {
  result: IntegrationCheckersDataIntegrationCheckerScenarioResult,
  dashboardUrl: string,
};
/**
 * Renders the subtext under the title for the particular payment that was created.
 * @param {IntegrationCheckerResult} props.result
 */
const LastChecked = (props: IntegrationCheckerResultProps) => {
  const {result, dashboardUrl} = props;

  if (!result || !result.target_object_created || !result.target_object_id) {
    return <Body color="gray">No test payment found.</Body>;
  }

  const {
    target_object_created: targetObjectCreated,
    target_object_id: targetObjectId,
  } = result;

  return (
    <Body color="gray">
      Tested{' '}
      <Moment fromNow interval={30 * 1000} date={targetObjectCreated * 1000} />
      {'. '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${dashboardUrl}/test/payments/${targetObjectId}`}
      >
        View test payment.
      </a>
    </Body>
  );
};

export default LastChecked;
